import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, TrendingUp, Tag } from "lucide-react";
import { forSaleText } from "@/lib/proacText";

export default function BusinessCard({ b, index = 0, active = false, onHover }) {
  const navigate = useNavigate();
  return (
    <motion.div
      data-testid={`business-card-${b.business_id}`}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: Math.min(index * 0.05, 0.4) }}
      onMouseEnter={() => onHover && onHover(b.business_id)}
      onMouseLeave={() => onHover && onHover(null)}
      onClick={() => navigate(`/entreprise/${b.business_id}`)}
      className={`bg-white border ${active ? "border-[#E0C173] shadow-md" : "border-gray-200"} shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer flex flex-col group`}
    >
      <div className="relative h-44 overflow-hidden">
        <img src={b.hero_image} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <span className="absolute top-3 left-3 bg-[#1B2A4A] text-white text-[11px] uppercase tracking-wider px-3 py-1">
          {b.sector}
        </span>
        {b.status === "sold" && (
          <span className="absolute top-3 right-3 bg-red-600 text-white text-[11px] uppercase tracking-wider px-3 py-1">Cédée</span>
        )}
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-display text-lg text-[#1B2A4A] leading-snug">{b.title}</h3>
        <p className="mt-2 text-sm text-[#475569] line-clamp-2 flex-1">{forSaleText(b.title, b.short_description, b.status === "sold")}</p>
        <div className="mt-4 flex items-center justify-between border-t border-gray-100 pt-4">
          <div className="flex items-center gap-1.5 text-xs text-[#475569]">
            <MapPin className="w-4 h-4 text-[#E0C173]" strokeWidth={1.5} />
            {[b.city, b.region].filter(Boolean).join(", ")}
          </div>
          {b.profitability_rate != null && (
            <div className="flex items-center gap-1.5 text-sm font-semibold text-[#1B2A4A]">
              <TrendingUp className="w-4 h-4 text-[#E0C173]" strokeWidth={1.5} />
              {b.profitability_rate}%
            </div>
          )}
        </div>
        <div className="mt-3 flex items-center gap-1.5 text-xs text-[#475569]">
          <Tag className="w-3.5 h-3.5 text-[#E0C173]" strokeWidth={1.5} /> {b.asking_price_range}
          {b.reference && <span data-testid={`card-ref-${b.business_id}`} className="ml-auto text-[11px] uppercase tracking-wider text-[#94A3B8]">Réf. {b.reference}</span>}
        </div>
      </div>
    </motion.div>
  );
}
